/* Product manuals page (sections/aps-manuals.liquid).
 *
 * - The brand rail is built from the page's own brand sections, each with its count.
 * - The search box filters manuals by an index built here at load: each row's own text plus its
 *   brand heading. The list is long enough that carrying that text a second time in the markup
 *   cost about a quarter of the page, so the row no longer holds data-q or data-name.
 * - ?m=<old id> (an old /Manuals/<id>_<stamp>.pdf link, redirected here) opens the page on that
 *   product's manuals: the box names it, its rows are tinted and the first is scrolled to. One old
 *   product can carry several manuals (a brochure, a spec sheet, an install guide).
 * Without script the page is still the full list of links.
 */
(function () {
  var root = document.querySelector('.aps-manuals');
  if (!root) return;
  var list = root.querySelector('[data-mn-list]');
  var input = root.querySelector('[data-mn-search]');
  var count = root.querySelector('[data-mn-count]');
  var none = root.querySelector('[data-mn-none]');
  var nav = root.querySelector('[data-mn-brands]');
  var box = root.querySelector('[data-mn-brands-box]');
  var brands = Array.prototype.slice.call(list.querySelectorAll('section.mb'));
  var rows = Array.prototype.slice.call(list.querySelectorAll('li.mn'));

  // Search index, built once: the row's visible text (manual name and document type) and its brand.
  var hays = rows.map(function (li) {
    var b = li.closest('section.mb');
    var h = b && b.querySelector('h2');
    var brand = h && h.firstChild ? h.firstChild.textContent : '';
    var n = li.querySelector('.dl-n');          // the name and type only, not the shop link
    var t = ((n ? n.textContent : li.textContent) + ' ' + brand).toLowerCase().replace(/\s+/g, ' ');
    // A punctuation stripped copy too, so a brand written with stops is found without them:
    // "S.R. Smith" also answers "sr smith", and a part number answers with or without its hyphens.
    var flat = t.replace(/[.\-/&']/g, '');
    return flat === t ? t : t + ' ' + flat;
  });

  function nameOf(li) {
    var n = li.querySelector('.dl-n');
    return n && n.firstChild ? n.firstChild.textContent.trim() : '';
  }

  function say(n) {
    if (count) count.textContent = n === 1 ? '1 manual' : n.toLocaleString() + ' manuals';
  }

  // The rail sits under the sticky header; measure it rather than guess.
  var header = document.querySelector('header, .header-wrapper, #header-group');
  if (header) root.style.setProperty('--aps-mn-sticky', Math.round(header.getBoundingClientRect().height + 16) + 'px');

  // Open beside the list on a desktop, folded above it on a phone; follows a resize or rotation.
  var phone = window.matchMedia('(max-width: 767px)');
  function fold() { if (box) box.open = !phone.matches; }
  fold();
  if (phone.addEventListener) phone.addEventListener('change', fold);

  brands.forEach(function (b) {
    var h = b.querySelector('h2');
    if (!h || !b.id || !nav) return;
    var a = document.createElement('a');
    a.href = '#' + b.id;
    a.appendChild(document.createTextNode(h.firstChild.textContent.trim()));
    var n = document.createElement('span');
    n.textContent = b.querySelectorAll('li.mn').length;
    a.appendChild(n);
    a.addEventListener('click', function () {
      if (box && phone.matches) box.open = false;
    });
    nav.appendChild(a);
  });
  say(rows.length);

  function filter() {
    var words = (input.value || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
    var shown = 0;
    rows.forEach(function (li, i) {
      var hay = hays[i];
      var hit = words.every(function (w) { return hay.indexOf(w) !== -1; });
      li.hidden = !hit;
      if (hit) shown++;
    });
    brands.forEach(function (b) {
      b.hidden = !b.querySelector('li.mn:not([hidden])');
    });
    if (none) none.hidden = shown > 0;
    say(shown);
  }
  if (input) input.addEventListener('input', filter);

  var m = new URLSearchParams(location.search).get('m');
  if (m && /^\d+$/.test(m)) {
    var hits = rows.filter(function (li) { return li.getAttribute('data-oid') === m; });
    if (hits.length) {
      hits.forEach(function (li) { li.classList.add('on'); });
      var found = root.querySelector('[data-mn-found]');
      var name = root.querySelector('[data-mn-found-name]');
      if (found && name) {
        name.textContent = nameOf(hits[0]);
        found.hidden = false;
      }
      // The brand panels carry content-visibility, so on first load a panel below the fold has
      // only an estimated height and scrolling to a row inside one lands short. Lay this row's
      // own panel out first, then scroll to it.
      var sec = hits[0].closest('section.mb');
      if (sec) sec.style.contentVisibility = 'visible';
      hits[0].scrollIntoView({ block: 'center' });
    }
  }
})();
